<script>
import { mapState, mapActions, mapMutations } from 'vuex';

export default {
  name: 'ModuleUsersEditForm',
  computed: {
    ...mapState('user/item', [
      'item',
    ]),
    first_name: {
      get () {
        return this.item.first_name;
      },
      set (value) {
        const { item } = this;
        item.first_name = value;
        this.setItem(item);
      },
    },
    last_name: {
      get () {
        return this.item.last_name;
      },
      set (value) {
        const { item } = this;
        item.last_name = value;
        this.setItem(item);
      },
    },
    email: {
      get () {
        return this.item.email;
      },
      set (value) {
        const { item } = this;
        item.email = value;
        this.setItem(item);
      },
    },
    password: {
      get () {
        return this.item.plainPassword;
      },
      set (value) {
        const { item } = this;
        item.plainPassword = value;
        this.setItem(item);
      },
    },
  },
  methods: {
    ...mapActions('user/item', [
      'save',
      'fetch',
    ]),
    ...mapMutations('user/item', [
      'setItem',
      'reset',
    ]),
    localSave () {
      this.save()
        .then(() => {
          this.$router.push({ name: 'users-listing' });
        })
      ;
    },
  },
  created() {
    const { id } = this.$route.params;

    if (!id) {
      this.reset();

      this.$router.push({ name: 'users-listing' });

      return;
    }

    this.fetch(id);
  },
};
</script>
<template>
  <div class="box-padding">
    <h2>General</h2>
    <div class="form-group mt-3">
      <label for="first_name" class="d-block">First Name</label>
      <input id="first_name" class="form-control rounded-0" v-model="first_name" />
    </div>
    <div class="form-group mt-3">
      <label for="last_name" class="d-block">Last Name</label>
      <input id="last_name" class="form-control rounded-0" v-model="last_name" />
    </div>
    <div class="form-group mt-3">
      <label for="email" class="d-block">Email</label>
      <input id="email" type="email" class="form-control rounded-0" v-model="email" />
    </div>
    <div class="form-group mt-3">
      <label for="password" class="d-block">Password</label>
      <input id="password" class="form-control rounded-0" v-model="password" placeholder="If you don't want to change the password, leave it empty" />
    </div>
    <div class="form-group mt-3 text-right">
      <button class="btn btn-primary" @click="localSave">Save</button>
    </div>
  </div>
</template>
